import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Package} from "../../../model/package";
import {ProductService} from "../../../service/product.service";
import {Document} from "../../../model/document";

@Component({
  selector: 'app-products-container-mobile',
  templateUrl: './products-container-mobile.component.html',
  styleUrls: ['./products-container-mobile.component.css']
})
export class ProductsContainerMobileComponent implements OnInit {

  displayInfo: boolean = false;
  products: String[] = [];
  keys: String[] = [];
  productsMap: String [] = [];
  productsCategoryMap: String[] = [];
  productsByCategory: Object;
  documents: Array<Document> = new Array<Document>();
  mobile: boolean = false;

  constructor(private productService: ProductService) { }
  @Output() selectEvent = new EventEmitter();
  @Input() package: Package;
  @Input() hasAdditional = '';
  @Input() packages;

  ngOnInit(): void {
    this.initProducts();
    if (window.screen.width <= 1000) { // 768px portrait
      this.mobile = true;}
  }

  initProducts() {
    this.productService.getProductByCategory().subscribe(productsMap => {
      this.productsByCategory = JSON.parse(JSON.stringify(productsMap));
      this.keys = Object.keys(productsMap);
    });

  }

  getLongName(shortName) {
    let result;
    this.productService.getProducts().subscribe(products => {
        products.forEach(product => {
          if (product.nameShort === shortName)
            result = product.name_long.substr(0, 26);
          return;
        });
      }
    )
    ;


    return result ? result : shortName;
  }

  addDocument(name) {
    if (!this.hasDocument(name))
      this.documents.push(new Document(name));
    else {
      let index = -1;

      this.documents.forEach(function (item, i) {
        if (item.docname === name)
          index = i;
      })

      if (index > -1)
        this.documents.splice(index, 1);
    }
  }

  hasDocument(name) {
    let hasDocument = false;
    this.documents.forEach(function (document) {
      if (document.docname === name)
        hasDocument = true
    });
    return hasDocument;
  }

  displayInfoMessage() {
    this.displayInfo = true;
  }

}
